<template>
  <fragment>
    <div class="font-weight-bold font_size_1125rem v3_color_teal mb-3 border_bottom_1 border_bottom_light_teal">
        Your Job Opportunity 
    </div>
    <div
      v-if="isSomeCriteriaSet"
      :class="{
        'border_1 border_light_teal rounded_0 pb-3 scroll-job-opp': isSomeCriteriaSet,
        'scroll-section-height': isSomeCriteriaSet && isChangeJobCriteriaEnable === true || isSomeCriteriaSet,
        'scroll-section-height-large': isSomeCriteriaSet && isChangeJobCriteriaEnable === false && (isShowStep == 3 || isShowStep == 7),
        'scroll-section-height-extra-large': isSomeCriteriaSet && isChangeJobCriteriaEnable === false && isShowStep == 1,
      }"
      class="border_1 border_light_teal rounded_0 pb-3 scroll-job-opp"
    >
      <component
        v-for="componentData in componentsData"
        :is="componentData.name"
        :key="componentData.key"
        v-bind="componentData.props"
      />
    </div>
  </fragment>
</template>

<script>
import RecruiterIcoCriteriaResultSpecialty from '@/components/recruiter/ico/criteria/result/RecruiterIcoCriteriaResultSpecialty';
import { JOB_QUESTION_TYPES } from '@/store';
import RecruiterIcoCriteriaResultLocation from '@/components/recruiter/ico/criteria/result/RecruiterIcoCriteriaResultLocation';
import RecruiterIcoCriteriaResultJobQuestion from '@/components/recruiter/ico/criteria/result/RecruiterIcoCriteriaResultJobQuestion';
export default {
  name: 'RecruiterIcoCriteriaResults',
  components: {
    RecruiterIcoCriteriaResultSpecialty,
    RecruiterIcoCriteriaResultJobQuestion,
    RecruiterIcoCriteriaResultLocation,
  },
  props: {
    criteriaItems: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isChangeJobCriteriaEnable: {
      type: Boolean,
      default: false,
    },
    isShowStep:{
      type:Number
    }
  },
  computed: {
    isSomeCriteriaSet: function () {
      return this.componentsData.some((i) => i.isVisible);
    },
    componentsData: function () {
      return this.criteriaItems.reduce((data, item) => {
        if (!item.value) return data;
        switch (item.talent_type) {
          case JOB_QUESTION_TYPES.LOCATION:
            if (Object.keys(item.value).length && item.value.location_zip_code) {
              data.push({
                name: RecruiterIcoCriteriaResultLocation.name,
                key: item.id,
                props: {
                  jobQuestion: item,
                },
                isVisible: !!item.value,
              });
            }
            break;
          case JOB_QUESTION_TYPES.SPECIALTY:
            if (
              !Object.keys(item.value).length ||
              !(item.value.specialtyId || item.value.subspecialtyId)
            )
              return data;
            data.push({
              name: RecruiterIcoCriteriaResultSpecialty.name,
              key: item.id,
              props: {
                jobQuestion: item,
              },
              isVisible: !!item.value,
            });
            break;
          default:
            if (
              !(Array.isArray(item.value) && item.value.length) &&
              !Object.keys(item.value).length
            )
              return data;
            data.push({
              name: RecruiterIcoCriteriaResultJobQuestion.name,
              key: item.id,
              props: {
                jobQuestion: item,
              },
              isVisible:
                item.value &&
                ((Array.isArray(item.value) && item.value.length) ||
                  Object.keys(item.value).length),
            });
        }
        return data;
      }, []);
    },
  },
};
</script>

<style scoped>
.scroll-job-opp{
  overflow-y: scroll;
  display: flex;
  align-items: center;
  flex-flow: column;
}
.scroll-section-height{
  height:150px;
}
.scroll-section-height-large{
  height: 450px;
}
.scroll-section-height-extra-large{
  height: 610px;
}
@media screen and (max-width: 768px) {
  .scroll-section-height{
  height:200px !important;
  }
  .scroll-section-height-large{
    height: 200px !important;
  }
  .scroll-section-height-extra-large{
    height: 200px !important;
  }
}
</style>
